import { render, staticRenderFns } from "./ClosedForDeliveryDialog.vue?vue&type=template&id=49e1c5c5&scoped=true"
import script from "./ClosedForDeliveryDialog.vue?vue&type=script&lang=js"
export * from "./ClosedForDeliveryDialog.vue?vue&type=script&lang=js"
import style0 from "./ClosedForDeliveryDialog.vue?vue&type=style&index=0&id=49e1c5c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e1c5c5",
  null
  
)

export default component.exports